import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'fxch-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  constructor(private readonly router: Router,
              private readonly spinnerService: NgxSpinnerService,
              public readonly toastr: ToastrService) {
  }

  successLogin(user) {
    localStorage.setItem('currentAdmin', JSON.stringify(
      {
        username: user.username,
        permissions: user.applicationRoles['ADMIN_DASHBOARD'].permissions,
        role: user.applicationRoles['ADMIN_DASHBOARD'].role,
        token: user.token
      }
    ));
    this.router.navigateByUrl('user-management');
  }

  decreaseFunction() {
    // this.spinnerService.hide();
  }

  increaseFunction() {
    // this.spinnerService.show();
  }
}
